
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

import {
  Group, GroupMaintenanceExtension,
  ListItem,
} from '../../../backend/backendapi';

import EditModal from '../../../group/Editmodal.vue';
import GroupMaintenanceExtensionStore from "../../../../stores/GroupMaintenanceExtensionStore";
import ExternalUserSelectModalTab
  from "../../../group/EditModal/ExternalUserSelectModal/ExternalUserSelectModalTab.vue";
import Groups from "../../../group/Groups.vue";
import Spinner from "../../../util/Spinner.vue";
import TabSlot from "../../../group/EditModal/TabSlot.vue";
import GroupCellEditor from "./GroupCellEditor.vue";
import { GroupSelector } from '../../../group/util';

@Component({
  components: {
    EditModal,
    GroupCellEditor,
    Groups,
    Spinner,
    TabSlot,
  },
})
export default class GroupsForMaintenanceEditModal extends Vue {
  @Prop({required: true})
  readonly groups!: GroupMaintenanceExtension[];
  @Prop({required: true})
  readonly allUsers!: ListItem[];
  @Prop({ default: 'group' })
  readonly groupSelector!: GroupSelector<GroupMaintenanceExtension>;
  @Prop({default: () => (g: GroupMaintenanceExtension) => GroupMaintenanceExtension.fromJS(g)})
  readonly groupCopyFunction!: ((t: GroupMaintenanceExtension) => GroupMaintenanceExtension);
  @Prop({default: null})
  readonly groupSaveFunction!: ((t: GroupMaintenanceExtension) => Promise<GroupMaintenanceExtension>) | null;

  readonly store = new GroupMaintenanceExtensionStore();

  GroupMaintenanceExtension = GroupMaintenanceExtension;
  
  async mounted(): Promise<void> {
    await this.store.reload();
  }

  public open(group: GroupMaintenanceExtension): void {
    (this.$refs.editmodal as EditModal).open(group);
  }

  public dismiss(): void {
    (this.$refs.editmodal as EditModal).dismiss();
  }
}
